export default "__VITE_ASSET__DG0bFIb6__"